"use client";

import { MouseEventHandler, useEffect, useRef, useState } from "react";
import { CopyCardProps } from "./types";
import { cn } from "@/lib/utils";

export const CopyCard = ({ title, content, onCopy, testId = "" }: CopyCardProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const anchor = useRef<HTMLDivElement>(null);

  const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onCopy();
    setIsCopied(true);
  };

  useEffect(() => {
    const onClickBody = () => {
      setIsCopied(false);
    };
    document.body.addEventListener("click", onClickBody);

    return () => document.body.removeEventListener("click", onClickBody);
  }, []);

  return (
    <>
      {content && (
        <div className="relative">
          <div data-testid={testId} ref={anchor} className="w-full bg-cede-bg-dark rounded-large overflow-hidden">
            <button
              data-testid={`${testId}-action`}
              onClick={onClick}
              className="w-full flex flex-col items-start py-2 px-4 hover:bg-cede-bg-component transition-colors text-left"
            >
              <p className="text-xs text-cede-text-secondary mb-2">{title}</p>
              <p className="text-base text-cede-text-primary break-all whitespace-pre-line text-start">{content}</p>
            </button>
          </div>
          {isCopied && anchor.current && (
            <div
              className={cn(
                "absolute top-full left-1/2 -translate-x-1/2 mt-2 z-tooltip",
                "flex p-2 text-cede-text-primary text-xs rounded-lg bg-cede-bg-component",
                "shadow-[0px_5px_5px_-3px_rgba(0,0,0,0.8),0px_8px_10px_1px_rgba(0,0,0,0.8),0px_3px_14px_2px_rgba(0,0,0,0.8)]",
                "animate-in fade-in duration-350",
              )}
            >
              Copied!
            </div>
          )}
        </div>
      )}
    </>
  );
};
